import React from 'react';
import { BusIcon, SkylinkIcon, WalkIcon } from '../../../../../../ui';
import { ParkingProductTransferDetailsType } from '../../../../domain/parking-product/models/IParkingProduct';
import { StyledParkingProductCardSubtitle } from './StyledParkingProductCard';

interface IParkingProductTransferDetailsProps {
	type?: ParkingProductTransferDetailsType;
	time?: string;
	description?: string;
}

export const ParkingProductTransferDetails = ({
	type,
	time,
	description,
}: IParkingProductTransferDetailsProps) => {
	if (!type && !description) {
		return null;
	}

	return (
		<StyledParkingProductCardSubtitle>
			{type && <TransferDetailsIcon type={type} />}
			{description && <span>{description}</span>}
			{description && time && ' - '}
			{time && <span>{time}</span>}
		</StyledParkingProductCardSubtitle>
	);
};

interface ITransferDetailsIconProps {
	type: ParkingProductTransferDetailsType;
}

const TransferDetailsIcon = ({ type }: ITransferDetailsIconProps) => {
	if (type === 'Bus') {
		return <BusIcon aria-hidden="true" />;
	}

	if (type === 'Walk') {
		return <WalkIcon aria-hidden="true" />;
	}

	if (type === 'Train') {
		return <SkylinkIcon aria-hidden="true" />;
	}

	return null;
};
